import React from 'react'
import { meerkatFav } from '../../assets/images'

const ProfilePicture = ({ photo, size, circle, style }) => (
  <img src={photo && photo.url ? photo.url : { meerkatFav } } alt={""} style={{ width: size, height: size, ...(circle ? { borderRadius: size / 2 } : {}), ...style }} />
)

export default ProfilePicture
